import React from 'react';
import { Link } from 'react-router-dom';

import Abstract from './report/Abstract';
import DataModel from './report/DataModel';
import Formalism from './report/Formalism';
import Implementation from './report/Implementation';
import InputScaling from './report/InputScaling';
import SpectralRadius from './report/SpectralRadius';
import Results from './report/Results';
import Discussion from './report/Discussion';
import FutureWorks from './report/FutureWorks';

const heading = {
  fontFamily: 'Roboto',
  fontWeight: '400',
  paddingTop: '0.5em',
  borderBottom: '2px solid rgb(100,100,100)'
}

function link_1() {
  return <a href="http://www.scholarpedia.org/article/Echo_state_network" target="_blank" rel="noopener noreferrer">1</a>
}
function link_2() {
  return <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2924583/" target="_blank" rel="noopener noreferrer">2</a>
}
function link_3() {
  return <a href="https://arxiv.org/abs/2007.09309" target="_blank" rel="noopener noreferrer">3</a>
}
function link_4() {
  return <a href="http://www.scholarpedia.org/article/Mackey-Glass_equation" target="_blank" rel="noopener noreferrer">4</a>
}

function App() {
  return (
    <div className="container px-4 px-md-6 px-lg-10" style={{ maxWidth: '1200px' }}>
      <div className="pt-2 w-100 d-flex flex-row flex-row-reverse">
        <Link to="/Report">
          <button className="btn btn-light active" style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}>Report</button>
        </Link>
        <Link to="/Board">
          <button className="btn btn-light" style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}>Board</button>
        </Link>
      </div>
      <div className="row">
        <h1 className="w-100" style={heading}>Predicting Chaos with an Echo State Network</h1>
        <h5>Tammy Lam</h5>
      </div>
      <div className="row">
        <div className="p-4 list-group bg-light">
          <a href="#Abstract" className="list-item">1 Asbtract</a>
          <a href="#Data_model" className="list-item">2 Data model</a>
          <a href="#Reservoir_model" className="list-item">3 Reservoir model</a>
          <div className="list-group">
            <a href="#Formalism" className="list-item pl-4">3.1 Formalism</a>
            <a href="#Implementation" className="list-item pl-4">3.2 Implementation</a>
            <a href="#Input_scaling" className="list-item pl-4">3.3 Input scaling</a>
            <a href="#Spectral_radius" className="list-item pl-4">3.4 Spectral radius</a>
          </div>
          <a href="#Results" className="list-item">5 Results</a>
          <div>
            <a href="#Discussion">6 Discussion</a>
          </div>
          <div>
            <a href="#Future_works">7 Future Works</a>
          </div>
          <div>
            <a href="#References">8 References</a>
          </div>
        </div>
      </div>
      <div id="Abstract" className="row">
        <h2 className="w-100" style={heading}>Abstract</h2>
      </div>
      <Abstract />
      <div id="Data_model" className="row">
        <h2 className="w-100" style={heading}>Data Model</h2>
      </div>
      <DataModel />
      <div id="Reservoir_model" className="row">
        <h1 className="w-100" style={heading}>Reservoir Model</h1>
      </div>
      <Formalism />
      <Implementation />
      <InputScaling />
      <SpectralRadius />
      <div id="Results" className="row">
        <h2 className="w-100" style={heading}>Results</h2>
      </div>
      <Results />
      <div id="Discussion" className="row">
        <h2 className="w-100" style={heading}>Discussion</h2>
      </div>
      <Discussion />
      <div id="Future_works" className="row">
        <h2 className="w-100" style={heading}>Future Works</h2>
      </div>
      <FutureWorks />
      <div id="References" className="row">
        <h2 className="w-100" style={heading}>References</h2>
        <p>
          [{ link_1() }] <a href="http://www.scholarpedia.org/article/Echo_state_network" target="_blank" rel="noopener noreferrer">Echo State Network</a> dx.doi.org/10.4249/scholarpedia.2330
        </p>
        <p>
          [{ link_2() }]
          W. Mather et al., <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2924583/" target="_blank" rel="noopener noreferrer">"Delay-Induced Degrade-and-Fire Oscillations in Small Genetic Circuits"</a> doi:10.1103/PhysRevLett.102.068105
        </p>
        <p>
          [{ link_3() }]
          B. Karamched et al., <a href="https://arxiv.org/abs/2007.09309" target="_blank" rel="noopener noreferrer">"Delay-induced Uncertainty in Physiological Systems"</a> arXiv:2007.09309
        </p>
        <p>
          [{ link_4() }] <a href="http://www.scholarpedia.org/article/Mackey-Glass_equation" target="_blank" rel="noopener noreferrer">Mackey-Glass Equation</a> doi:10.4249/scholarpedia.6908
        </p>
      </div>
    </div>
  );
}

export default App;
